import { render, staticRenderFns } from "./_base-bordered-actions.vue?vue&type=template&id=3be92b21&scoped=true&"
import script from "./_base-bordered-actions.vue?vue&type=script&lang=js&"
export * from "./_base-bordered-actions.vue?vue&type=script&lang=js&"
import style0 from "./_base-bordered-actions.vue?vue&type=style&index=0&id=3be92b21&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be92b21",
  null
  
)

export default component.exports